import reviewsData from '../data/reviews.json';

// Single source of truth for review-derived structured data. Both the aggregate
// rating and the per-review nodes are computed from reviews.json so the JSON-LD
// can never claim a rating the visible reviews don't support (hardcoded /
// unverifiable ratings risk a Google rich-results manual action).

const BEST_RATING = 5;
const WORST_RATING = 1;

// Average star rating across all reviews, rounded to one decimal, as a
// Schema.org AggregateRating node with numeric values. Returns null when there
// are no reviews so callers can omit aggregateRating entirely.
export const getAggregateRating = () => {
    if (!reviewsData.length) {
        return null;
    }

    const total = reviewsData.reduce((sum, review) => sum + review.rating, 0);
    const ratingValue = Math.round((total / reviewsData.length) * 10) / 10;

    return {
        '@type': 'AggregateRating',
        ratingValue,
        reviewCount: reviewsData.length,
        bestRating: BEST_RATING,
        worstRating: WORST_RATING,
    };
};

// Schema.org Review nodes for each review, suitable for the `review` array of a
// business/accommodation entity.
export const buildReviewSchemaList = () =>
    reviewsData.map((review) => ({
        '@type': 'Review',
        reviewRating: {
            '@type': 'Rating',
            ratingValue: review.rating,
            bestRating: BEST_RATING,
            worstRating: WORST_RATING,
        },
        author: {
            '@type': 'Person',
            name: review.author,
        },
        datePublished: review.date,
        reviewBody: review.text,
    }));
